import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const FAQ = () => {

  const faqNumberStyle = {
    color: "#aaa",
    marginRight: "16px"
  }

  const faqDescStyle = {
    paddingLeft: '30px'
  }

  return (
    <section className='faq-section'>
      <div className='faq-container'>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>
              <span style={faqNumberStyle}>1.</span>
              <span>What is DressTwin?</span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography style={faqDescStyle}>
            DressTwin is A social fashion marketplace where every item you see fits you—literally.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>
              <span style={faqNumberStyle}>2.</span>
              <span>Who can join?</span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography style={faqDescStyle}>
            DressTwin is a invite only community for fashion addicts referred by other members via referral code. 
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>
              <span style={faqNumberStyle}>3.</span>
              <span>I do not have referral code</span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography style={faqDescStyle}>
              Click "REQUEST CODE" button on the registration page, and fill refferal code request form and you might get lucky to get an access. 
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </section>
  );
}

export default FAQ